import { Observable } from 'rxjs';
import { User } from '@spartacus/core';

export abstract class UserCurrentAdapter {
  abstract load(userId: string): Observable<User>;
}
